export const COMMON_NATIONALITIES = [
  'American', 'Argentinian', 'Australian', 'Austrian', 'Bahraini',
  'Belgian', 'Brazilian', 'British', 'Canadian', 'Chilean',
  'Chinese', 'Colombian', 'Czech', 'Danish', 'Dutch',
  'Egyptian', 'Emirati', 'Filipino', 'Finnish', 'French',
  'German', 'Greek', 'Hungarian', 'Indian', 'Indonesian',
  'Irish', 'Israeli', 'Italian', 'Japanese', 'Kenyan',
  'Korean', 'Kuwaiti', 'Lebanese', 'Malaysian', 'Mexican',
  'Moroccan', 'New Zealander', 'Nigerian', 'Norwegian', 'Omani',
  'Pakistani', 'Peruvian', 'Polish', 'Portuguese', 'Qatari',
  'Romanian', 'Russian', 'Saudi', 'Singaporean', 'South African',
  'Spanish', 'Swedish', 'Swiss', 'Thai', 'Turkish',
  'Ukrainian', 'Vietnamese',
];

export const COUNTRY_CAPITAL_MAP: Record<string, string> = {
  'United States': 'Washington D.C., United States',
  'United Kingdom': 'London, United Kingdom',
  'Canada': 'Ottawa, Canada',
  'Australia': 'Canberra, Australia',
  'Germany': 'Berlin, Germany',
  'France': 'Paris, France',
  'Spain': 'Madrid, Spain',
  'Italy': 'Rome, Italy',
  'Netherlands': 'Amsterdam, Netherlands',
  'Belgium': 'Brussels, Belgium',
  'Switzerland': 'Bern, Switzerland',
  'Sweden': 'Stockholm, Sweden',
  'Norway': 'Oslo, Norway',
  'Denmark': 'Copenhagen, Denmark',
  'Finland': 'Helsinki, Finland',
  'Austria': 'Vienna, Austria',
  'Ireland': 'Dublin, Ireland',
  'Poland': 'Warsaw, Poland',
  'Portugal': 'Lisbon, Portugal',
  'Greece': 'Athens, Greece',
  'United Arab Emirates': 'Abu Dhabi, United Arab Emirates',
  'Saudi Arabia': 'Riyadh, Saudi Arabia',
  'Qatar': 'Doha, Qatar',
  'Kuwait': 'Kuwait City, Kuwait',
  'Bahrain': 'Manama, Bahrain',
  'Oman': 'Muscat, Oman',
  'India': 'New Delhi, India',
  'China': 'Beijing, China',
  'Japan': 'Tokyo, Japan',
  'Singapore': 'Singapore, Singapore',
  'South Korea': 'Seoul, South Korea',
  'Hong Kong': 'Hong Kong, Hong Kong',
  'Malaysia': 'Kuala Lumpur, Malaysia',
  'Thailand': 'Bangkok, Thailand',
  'Indonesia': 'Jakarta, Indonesia',
  'Philippines': 'Manila, Philippines',
  'Vietnam': 'Hanoi, Vietnam',
  'New Zealand': 'Wellington, New Zealand',
  'South Africa': 'Pretoria, South Africa',
  'Brazil': 'Brasilia, Brazil',
  'Mexico': 'Mexico City, Mexico',
  'Argentina': 'Buenos Aires, Argentina',
  'Chile': 'Santiago, Chile',
  'Colombia': 'Bogota, Colombia',
  'Peru': 'Lima, Peru',
  'Israel': 'Jerusalem, Israel',
  'Turkey': 'Ankara, Turkey',
  'Romania': 'Bucharest, Romania',
  'Czech Republic': 'Prague, Czech Republic',
  'Hungary': 'Budapest, Hungary',
  'Nigeria': 'Abuja, Nigeria',
  'Kenya': 'Nairobi, Kenya',
  'Egypt': 'Cairo, Egypt',
  'Morocco': 'Rabat, Morocco',
};

export const COMMON_LOCATIONS = [
  'Abu Dhabi, United Arab Emirates',
  'Amsterdam, Netherlands',
  'Ankara, Turkey',
  'Athens, Greece',
  'Auckland, New Zealand',
  'Bangkok, Thailand',
  'Barcelona, Spain',
  'Beijing, China',
  'Berlin, Germany',
  'Bogota, Colombia',
  'Brasilia, Brazil',
  'Brussels, Belgium',
  'Bucharest, Romania',
  'Budapest, Hungary',
  'Buenos Aires, Argentina',
  'Cairo, Egypt',
  'Canberra, Australia',
  'Chicago, United States',
  'Copenhagen, Denmark',
  'Doha, Qatar',
  'Dubai, United Arab Emirates',
  'Dublin, Ireland',
  'Helsinki, Finland',
  'Hong Kong, Hong Kong',
  'Istanbul, Turkey',
  'Jakarta, Indonesia',
  'Jerusalem, Israel',
  'Kuala Lumpur, Malaysia',
  'Kuwait City, Kuwait',
  'Lima, Peru',
  'Lisbon, Portugal',
  'London, United Kingdom',
  'Los Angeles, United States',
  'Madrid, Spain',
  'Manama, Bahrain',
  'Manila, Philippines',
  'Melbourne, Australia',
  'Mexico City, Mexico',
  'Miami, United States',
  'Milan, Italy',
  'Montreal, Canada',
  'Moscow, Russia',
  'Mumbai, India',
  'Munich, Germany',
  'Muscat, Oman',
  'Nairobi, Kenya',
  'New Delhi, India',
  'New York, United States',
  'Oslo, Norway',
  'Ottawa, Canada',
  'Paris, France',
  'Prague, Czech Republic',
  'Pretoria, South Africa',
  'Riyadh, Saudi Arabia',
  'Rome, Italy',
  'San Francisco, United States',
  'Santiago, Chile',
  'Sao Paulo, Brazil',
  'Seoul, South Korea',
  'Shanghai, China',
  'Singapore, Singapore',
  'Stockholm, Sweden',
  'Sydney, Australia',
  'Tel Aviv, Israel',
  'Tokyo, Japan',
  'Toronto, Canada',
  'Vienna, Austria',
  'Warsaw, Poland',
  'Washington D.C., United States',
  'Wellington, New Zealand',
  'Zurich, Switzerland',
];

export const TONE_OPTIONS = [
  { value: 'friendly_casual', label: 'Friendly & Casual' },
  { value: 'professional', label: 'Professional' },
  { value: 'direct', label: 'Direct' },
];
